import i18n from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Logo from "../Logo";

import { content } from "../../utils/content";
import { NAV_ROUTES, NAV_SUBROUTES } from "../../utils/routes";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="flex bg-gray-900 items-center justify-center w-full z-10">
      <div className="flex flex-col items-center justify-center max-w-screen-2xl px-10 py-10 space-y-8 w-full">
        <div className="flex flex-col items-start justify-start space-x-0 space-y-10 w-full sm:flex-row sm:space-x-2 sm:space-y-0">
          <div className="flex flex-col justify-between space-y-5 w-full sm:w-2/3">
            <p className="font-bold text-sm text-white">IP8Value</p>

            <div className="flex flex-col h-full justify-between space-y-3">
              <div className="flex flex-col justify-start space-y-1 sm:flex-row sm:items-center sm:space-x-2 sm:space-y-0">
                <p className="capitalize font-bold text-sm text-white">
                  {t("address")}
                </p>

                <div className="bg-white hidden h-1 min-w-1 rounded-full sm:block" />

                <p className="capitalize font-normal text-sm text-white">
                  {content.footer.address}
                </p>
              </div>

              <div className="flex flex-col justify-start space-y-1 sm:flex-row sm:items-center sm:space-x-2 sm:space-y-0">
                <p className="capitalize font-bold text-sm text-white">
                  {t("email")}
                </p>

                <div className="bg-white hidden h-1 min-w-1 rounded-full sm:block" />

                <a
                  className="no-underline"
                  href={`mailto:${content.footer.email}`}
                >
                  <p className="font-normal text-sm text-white">
                    {content.footer.email}
                  </p>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-row items-start justify-between w-full sm:w-1/2 lg:w-1/3">
            <div className="flex flex-col h-full justify-between space-y-5">
              <Link to={`${i18n.language}/`} className="no-underline">
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_ROUTES.get("HOME").LABEL)}
                </p>
              </Link>

              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("OVERVIEW").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("OVERVIEW").LABEL)}
                </p>
              </Link>

              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("ABOUT").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("ABOUT").LABEL)}
                </p>
              </Link>
            </div>

            <div className="flex flex-col h-full justify-between space-y-5">
              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("VALUE").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("VALUE").LABEL)}
                </p>
              </Link>

              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("PRODUCT").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("PRODUCT").LABEL)}
                </p>
              </Link>

              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("DOCS").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("DOCS").LABEL)}
                </p>
              </Link>
            </div>

            <div className="flex flex-col h-full justify-between space-y-5">
              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("BLOG").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("BLOG").LABEL)}
                </p>
              </Link>

              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("EVENTS_LIST").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("EVENTS_LIST").LABEL)}
                </p>
              </Link>

              <Link
                to={`${i18n.language}/${NAV_SUBROUTES.get("CONTACT").PATH}`}
                className="no-underline"
              >
                <p className="capitalize font-normal text-sm text-white">
                  {t(NAV_SUBROUTES.get("CONTACT").LABEL)}
                </p>
              </Link>
            </div>
          </div>
        </div>

        <hr className="border-gray-600 w-full" />

        <div className="flex flex-col items-start justify-between space-y-4 w-full sm:flex-row sm:items-center sm:space-y-0">
          <Logo isLightTheme={true} />

          <p className="text-start text-xs text-white">
            {t("Copyright")} © {new Date().getFullYear()} Mindtranz Pte. Ltd. {t("All Rights Reserved")}. {t("Co. Reg No.")}: 202532781H
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
